module.exports = __webpack_public_path__ + "img/43_16.8ded82e6.png";